import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

const getFontSize = () => {
  const width = window.innerWidth;
  if (width < 1900) return '1rem';
  return '2.5rem';
};

const MotionText = () => {
  const fontSize = getFontSize();
  // State variable to control re-rendering of the Box component
  const [key, setKey] = useState(0);

  // The text to be animated, split into an array of characters
  const text = "Turn logs into a node graph and start exploring connections.".split('');

  // Calculate the total duration of the animation
  // Each character animation lasts 0.25 seconds, with a 0.1 second delay between each character
  const totalDuration = 0.25 * text.length + 0.1 * (text.length - 1);

  // Function to reset the animation by incrementing the key state variable
  const resetAnimation = () => {
    setKey(prevKey => prevKey + 1);
  };

  // useEffect hook to set a timer that resets the animation after the total duration
  useEffect(() => {
    // Set a timer to call resetAnimation after the total duration
    const timer = setTimeout(resetAnimation, totalDuration * 500);
    
    // Cleanup function to clear the timer when the component unmounts or key/totalDuration changes
    return () => clearTimeout(timer);
  }, [key, totalDuration]);

  return (
    // Box component with a key prop to trigger re-rendering
    <Box 
      key={key}
      display="flex" // Use flexbox for centering
      justifyContent="center" // Center horizontally
      alignItems="center" // Center vertically
      height="100vh" // Full viewport height to center vertically
      sx={{ p: 4 }}
  >
      {text.map((el, i) => (
        <motion.span
          initial={{ 
            opacity: 0,
            y: 20 // Start slightly below
          }}
          animate={{ 
            opacity: 1,
            y: 0
          }}
          transition={{
            duration: 0.50,
            delay: i / 10
          }}
          key={i}
          style={{ 
            display: 'inline-block',
            fontSize: fontSize,
            fontFamily: '"Courier New", monospace', // Terminal-style font
            fontWeight: 'bold',
            letterSpacing: '2px'
          }}
        >
          {el === ' ' ? '\u00A0' : el} {/* Render non-breaking space for spaces */}
        </motion.span>
      ))}
    </Box>
  );
};

export default MotionText;